import { Col, Divider } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import Panel from '../../Panel/Panel';
import NavHeader from '../NavHeader/NavHeader';
import NavList from '../NavList/NavList';
import './Navigation.scss';

export interface INavigationProps {
  className?: string | object;
  open: boolean;
  toggleMenu: () => void;
}

function Navigation(props: INavigationProps) {
  const { className, open, toggleMenu } = props;
  const classes = classNames('navigation', 'no-print', className);

  return (
    <Panel medium={true} open={open} className={classes}>
      <Col>
        <NavHeader toggleMenu={toggleMenu} />
        <Divider />
        <NavList />
      </Col>
    </Panel>
  );
}

export default Navigation;
